if (!customElements.get('wishlist-button')) {
  customElements.define(
    'wishlist-button',
    class WishlistButton extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button');
        this.product = { id: this.dataset.productId, handle: this.dataset.productHandle };
        this.addLabel = this.dataset.addLabel;
        this.removeLabel = this.dataset.removeLabel;
      }

      connectedCallback() {
        this.render(Wishlist.has(this.product.id));
        this.onClick = this.toggle.bind(this);
        this.button.addEventListener('click', this.onClick);
        this.unsubscribe = subscribe(Wishlist.EVENT, () => this.render(Wishlist.has(this.product.id)));
      }

      disconnectedCallback() {
        this.button.removeEventListener('click', this.onClick);
        if (this.unsubscribe) this.unsubscribe();
      }

      toggle() {
        const added = Wishlist.toggle(this.product);
        if (window.WishlistAnalytics) {
          WishlistAnalytics.track(added ? 'wishlist_add' : 'wishlist_remove', this.product);
        }
      }

      render(isWishlisted) {
        const text = isWishlisted ? this.removeLabel : this.addLabel;
        this.button.setAttribute('aria-pressed', String(isWishlisted));
        this.button.setAttribute('aria-label', text);
        this.classList.toggle('wishlist-heart--active', isWishlisted);
      }
    }
  );
}
